import type { ToolApproval } from '@kirin/api-client/contracts/shadow-ai-tool-approvals';
import type { TableRowData } from '@/components/DataTable';

export type ToolApprovalBulkRow = TableRowData & {
  approval?: ToolApproval | null;
};

export interface ToolApprovalBulkIds {
  /** De-duplicated ids of the selected tools that are not approved yet. */
  approve: string[];
  /** De-duplicated ids of the selected tools that are approved. */
  unapprove: string[];
}

/**
 * Splits the selected rows into the tool ids each bulk action applies to.
 * One tool can back several rows (Running Now process rows, Installed category
 * rows), so ids are de-duplicated; each action only sends the tools whose state
 * it changes.
 */
export function getToolApprovalBulkIds<TRow extends ToolApprovalBulkRow>(
  rows: readonly TRow[],
  getToolId: (row: TRow) => string
): ToolApprovalBulkIds {
  const approve = new Set<string>();
  const unapprove = new Set<string>();
  for (const row of rows) {
    (row.approval ? unapprove : approve).add(getToolId(row));
  }
  return { approve: [...approve], unapprove: [...unapprove] };
}
